import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledWrapper = styled(FlexBox)`
    width: 100%;
    padding: 20px;
    background: linear-gradient(
        288deg,
        #ffb6b9 0%,
        #ffb6b9 35%,
        #fae3d9 calc(35% + 1px),
        #fae3d9 45%,
        #bbded6 calc(45% + 1px),
        #bbded6 65%,
        #61c0bf calc(65% + 1px),
        #61c0bf 100%
    );
    min-height: 200px;

    & h1 {
        color: ${({ theme }) => theme.colors.black};
        text-transform: uppercase;
        font-weight: 500;
        font-size: 25px;
        position: relative;
        display: inline-block;

        &:after,
        &:before {
            content: '';
            position: absolute;
            top: 50%;
            width: 50px;
            height: 2px;
            transform: translateY(-50%);
            background: ${({ theme }) => theme.colors.blue};
        }

        &:before {
            left: -60px;
        }

        &:after {
            right: -60px;
        }
    }

    ${media.sm`
        padding-top: 35px;
        padding-bottom: 35px;
  `}
    ${media.md`
        padding-top: 50px;
        padding-bottom: 50px;
  `}
`;

export const StyledBg = styled.div`
    animation: slide 3s ease-in-out infinite alternate;
    background-image: linear-gradient(-60deg, #168aad 50%, #73bfb8 50%);
    bottom: 0;
    left: -50%;
    opacity: 0.5;
    position: fixed;
    right: -50%;
    top: 0;
    z-index: -1;
`;
